import Detector from '@/assets/js/detector.js'

/**
 * Composable for app information (name, platform, version)
 * @returns {Object} Object containing APP_NAME, getPlatform, and getAppVersion
 */
export function useAppInfo() {
  /**
   * Get the application name
   * @returns {string} Application name
   */
  const getAppName = () => {
    return import.meta.env.VITE_APP_NAME || ''
  }

  /**
   * Get the current platform
   * @returns {string} Platform name (e.g., 'android', 'ios', 'web')
   */
  const getPlatform = () => {
    // Check if it's a mobile app
    if (import.meta.env.VITE_MOBILE_APP) {
      return 'MobileApp'
    }
    return 'Web'
  }

  /**
   * Get the application version
   * @returns {string} Application version
   */
  const getAppVersion = () => {
    return import.meta.env.VITE_APP_VERSION
  }
  return {
    getAppName,
    getPlatform,
    getAppVersion
  }
}
